import React, { useCallback, useState } from "react";
import { Button, Card } from "antd";

import { SettingsRecommendationModal } from "pages/Recommendations/components/SettingsRecommendationModal";
import { useAppDispatch } from "store";
import {
  createRecommendationAction,
  loadRecommendationsAction,
  loadServicesAction,
  deleteRecommendationAction,
  editRecommendationAction,
} from "store/recommendations/recommendations.actions";
import useListData, { LoadListDataParams } from "hooks/useListData";
import {
  ICreateRecommendation,
  IRecommendation,
  IRecommendationSettings,
  IServiceParams,
} from "types/recommendations.types";
import { RecommendationsList } from "../../components/RecommendationsList/RecommendationsList";
import { EditRecommendationModal } from "../../components/EditRecommendationModal";

export const WeRecommend = () => {
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [editEntity, setEditEntity] = useState<IRecommendation>();

  const handleListLoad = useCallback(
    (params: LoadListDataParams) => {
      return dispatch(loadRecommendationsAction(params));
    },
    [dispatch]
  );

  const { items, loading, loadData, pagination, onTableChange } =
    useListData(handleListLoad);

  const reloadListData = useCallback(() => {
    return loadData({
      page: pagination.current,
      pageSize: pagination.pageSize,
    });
  }, [loadData, pagination]);

  const handleShowModal = () => {
    setOpenModal(true);
  };

  const handleHideModal = () => {
    setOpenModal(false);
  };

  const handleEdit = async (id: number, values: IRecommendationSettings) => {
    // console.log('id', id, 'values', values);
    await dispatch(editRecommendationAction({ id, values }));
    handleEditHide();
    return reloadListData();
  };

  const handleSubmit = async (values: ICreateRecommendation) => {
    return dispatch(createRecommendationAction(values)).then(() =>
      reloadListData()
    );
  };

  const handleServicesLoad = useCallback(
    (params: LoadListDataParams<IServiceParams>) => {
      return dispatch(loadServicesAction(params));
    },
    [dispatch]
  );

  const handleEditClick = (value: IRecommendation) => {
    setEditEntity(value);
  };

  const handleEditHide = () => {
    setEditEntity(undefined);
  };

  const handleDelete = async (value: IRecommendation) => {
    await dispatch(deleteRecommendationAction({ id: value.id }));
    return reloadListData();
  };

  return (
    <>
      <Card
        title="Настроенные рекомендации"
        extra={
          <Button type="primary" onClick={handleShowModal}>
            Добавить
          </Button>
        }
      >
        <RecommendationsList
          items={items}
          loading={loading}
          onTableChange={onTableChange}
          pagination={pagination}
          onEdit={handleEditClick}
          onDelete={handleDelete}
        />
      </Card>
      {!!editEntity && (
        <EditRecommendationModal
          onSubmit={(values) => handleEdit(editEntity.id, values)}
          onHide={handleEditHide}
          initialValues={editEntity}
        />
      )}
      <SettingsRecommendationModal
        onLoad={handleServicesLoad}
        onSubmit={handleSubmit}
        visible={openModal}
        onHide={handleHideModal}
      />
    </>
  );
};
